import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { MaintenanceUser } from '../models/MaintenanceUser';
import { MaintenanceUserRole } from '../models/MaintenanceUserRole';
import {UserNames} from '../models/UserNames';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly userUrl = environment.userUrl;

  constructor(private readonly httpClient: HttpClient) {
  }

  getUsers(): Observable<MaintenanceUser[]> {
    return this.httpClient.get<MaintenanceUser[]>(this.userUrl).pipe(
      map(
        users => {
          return users.map((user) => {
            return MaintenanceUser.transformUser(user);
          })
        })
    );
  }

  getRoles(): Observable<MaintenanceUserRole[]> {
    return this.httpClient.get<MaintenanceUserRole[]>(this.userUrl + '/roles');
  }

  getUserById(id: string): Observable<MaintenanceUser> {
    return this.httpClient.get<MaintenanceUser>(this.userUrl + '/' + id).pipe(
      map((user) => {
        return MaintenanceUser.transformUser(user);
      })
    );
  }

  addUpdateUser(user: MaintenanceUser, add: boolean): Observable<MaintenanceUser> {
    if (add) {
      return this.addUser(user);
    } else {
      return this.updateUser(user);
    }
  }

  addUser(user: MaintenanceUser): Observable<MaintenanceUser> {
    return this.httpClient.post<MaintenanceUser>(this.userUrl , user).pipe(
      map((res) => {
        return MaintenanceUser.transformUser(res);
      }),
      catchError((err) => {
        console.log("Saving failed for user: " + user);
        return throwError(err);
      })
    );
  }

  updateUser(user: MaintenanceUser): Observable<MaintenanceUser> {
    return this.httpClient.put<MaintenanceUser>(this.userUrl , user).pipe(
      map((res) => {
        return MaintenanceUser.transformUser(res);
      }),
      catchError((err) => {
        console.log("Saving failed for user: " + user);
        return throwError(err);
      })
    );
  }

  getUserNames(gmin: string): Observable<UserNames> {
    return this.httpClient.get<UserNames>(this.userUrl + '/ad/' + gmin);
  }

  exists(name: string): Observable<boolean> {
    return this.httpClient.get<boolean>(this.userUrl + "/exists/" + name);
  }

}
